<template>
  <v-card class="mb-6">
    <v-toolbar flat color="white" dense>
      <h3 class="text-subtitle-2">Contas Bancárias e Chaves Pix</h3>
    </v-toolbar>
    <v-divider></v-divider>

    <v-tabs v-model="tab" color="primary" background-color="white">
      <v-tab class="text-capitalize" value="contas">Contas Bancárias</v-tab>
      <v-tab class="text-capitalize" value="chavespix">Chaves Pix</v-tab>
      <v-tabs-slider color="primary"></v-tabs-slider>
    </v-tabs>

    <v-divider></v-divider>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item name="contas" v-bind="$v.TABS_CONFIG">
        <!-- <tab-pecas :pecas.sync="ordemservico.pecas" @update:pecas="confirmar(false)"></tab-pecas> -->
        <tab-contas></tab-contas>
      </v-tab-item>
      
      <v-tab-item name="chavespix" v-bind="$v.TABS_CONFIG">
        <tab-chaves-pix></tab-chaves-pix>
      </v-tab-item>

    </v-tabs-items>
  </v-card>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, inject } from "vue";
import TabContas from "./TabContas.vue";
import TabChavesPix from "./TabChavesPix.vue";

const tab = ref('chavespix');

</script>

<style lang="scss" scoped>

</style>